
<div class="cep-content">
    <div class="cep-fields-grid">
        <div class="columns-data">
            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" >
                <mat-label>CEP Origem</mat-label>
                <input  matInput formControlName="origem" placeholder="CEP Origem"   #inp type = "text" mask="00000-000"> 
                <button tabindex="-1"  matSuffix mat-icon-button aria-label="Clear" (click)="clear('origem')" >
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div class="columns-data">
            <mat-form-field appearance="outline" [formGroup]="formValidation" class="no-padding-form-field cep-font" >
                <mat-label>CEP Destino</mat-label>
                <input  matInput formControlName="destino" placeholder="CEP Destino"   #inpDest type = "text" mask="00000-000"> 
                <button tabindex="-1"    matSuffix mat-icon-button aria-label="Clear" (click)="clear('destino')" *ngIf="inpDest!=null" >
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
    <button mat-raised-button color="success" (click)="pesquisar()">Pesquisar</button>
    <mat-label [ngStyle]="{'color' :sucesso?'green':'red'}" class="mensagem">
                {{message}}
    </mat-label>
</div>